import React, { useCallback, useState } from "react";
import { closeModal } from "../../../store/features/modal.js";
import { Modal } from "@shopify/polaris";
import { OPEN_MODAL_UNDO_CHANGES } from "../../../constants/modalTypes.js";
import UndoChangesTable from "./components/UndoChangesTable.js";
import ProductsList from "./components/ProductsList.js";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";
import { Text } from "@shopify/polaris";

const UndoChangesModal = () => {
  const dispatch = useAppDispatch();
  const { isOpen, modalType, modalData } = useAppSelector((state) => state.modal);
  const [productsIds, setProductsIds] = useState(null);

  const handleClose = useCallback(() => {
    setProductsIds(null);
    dispatch(closeModal());
  }, [setProductsIds]);

  return (
    <Modal
      open={isOpen && modalType === OPEN_MODAL_UNDO_CHANGES}
      onClose={handleClose}
      title="View History"
      secondaryActions={productsIds ? [{
        content: "Back", onAction: () => {
          setProductsIds(null);
        }
      }] : null}
    >
      <Modal.Section>
        {
          productsIds
            ?
            <ProductsList productsIds={productsIds} />
            : <>
              <div style={{ marginBottom: '14px' }}>
                <Text as="p" variant="bodyMd">Action history data will expire 90 days after the date it occurred</Text>
              </div>
              <UndoChangesTable handleClose={handleClose} actionId={modalData?.actionId} setProductsIds={setProductsIds} />
            </>
        }
      </Modal.Section>
    </Modal>
  );
};

export default UndoChangesModal;